import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from '@lingui/react';
import { t } from '@lingui/macro';
import { useLocalisation } from '@3plearning/lingui-cdn';

// Components
import Table from '../table/table';
import Checkbox, { LABEL_STYLES } from '../checkbox/checkbox';

// Helpers
import { stripCharacters } from '../../helpers/utils';

function AddStudentsList({ listOfRows, selectAllValue, selectAllCheckboxHandler, numberOfStudents }) {
    const { i18n } = useLocalisation();
    const listOfHeaders = [
        {
            key: stripCharacters(i18n._(t`Header - Select All`)),
            importedClasses: 'table__cell--checkbox',
            content: (
                <Checkbox
                    uid="addSelectAll"
                    isChecked={selectAllValue}
                    callback={selectAllCheckboxHandler}
                    labelText={<Trans id={'Header - Select All'} />}
                    inputType={LABEL_STYLES.hidden}
                />
            )
        },
        {
            key: stripCharacters(i18n._(t`Header - Students`)),
            content: (
                <Trans id={'Header - Students with value - {numberOfStudents}'}>
                    value {numberOfStudents}
                </Trans>
            )
        },
        {
            key: stripCharacters(i18n._(t`Header - Class name`)),
            content: <Trans id={'Header - Class name'} />
        },
        {
            key: stripCharacters(i18n._(t`Header - Group`)),
            content: <Trans id={'Header - Group'} />
        },
        {
            key: stripCharacters(i18n._(t`Header - Actions`)),
            content: <Trans id={'Header - Actions'} />
        }
    ];

    return (
        <Table
            listOfHeaders={listOfHeaders}
            listOfRows={listOfRows}
        />
    );
}

AddStudentsList.propTypes = {
    listOfRows: PropTypes.array.isRequired,
    selectAllValue: PropTypes.bool,
    selectAllCheckboxHandler: PropTypes.func,
    numberOfStudents: PropTypes.number
};

export default AddStudentsList;



// WEBPACK FOOTER //
// ./components/students-lists/add-students-list.js